import { createContext, useContext } from "react";

export type AbVariant = "a" | "b";

export type AbExperimentContextValue = {
  /** Server-assigned (or admin-overridden) variant for the current page's experiment. */
  variant: AbVariant | null;
  /** Human-readable label for the current variant. */
  variantLabel: string | null;
  /** True while the initial experiment fetch is in flight. */
  isLoading: boolean;
  /** Admin-only: manually force a variant. Pass null to clear the override. */
  setOverride: (variant: AbVariant | null) => void;
  /** Record a conversion event for the current variant. */
  recordConversion: (metadata?: Record<string, unknown>) => void;
};

export const abExperimentContextDefaults: AbExperimentContextValue = {
  variant: null,
  variantLabel: null,
  isLoading: false,
  setOverride: () => undefined,
  recordConversion: () => undefined,
};

export const AbExperimentContext = createContext<AbExperimentContextValue>(
  abExperimentContextDefaults
);

/**
 * Returns the current A/B experiment assignment for the page.
 * Variants are assigned by the server; only admins can override via the
 * AbExperimentOverlay.
 */
export function usePageExperiment(): AbExperimentContextValue {
  return useContext(AbExperimentContext);
}
